import "./index.scss";

const LeaderBar = ({ img, title, description }) => {
  return (
    <div className="daily-question">
      <img className="image" src={img} alt="daily question icon" />
      <div className="details">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
};
export default LeaderBar;
